(() => {
  const footer = document.querySelector('.k-footer');
  const dialog = document.querySelector('[data-k-footer-overlay]');
  const content = dialog?.querySelector('[data-k-footer-overlay-content]');
  const closeButton = dialog?.querySelector('[data-k-footer-overlay-close]');

  if (!footer || !dialog || !content || typeof dialog.showModal !== 'function') return;
  if (dialog.dataset.kReady === 'true') return;
  dialog.dataset.kReady = 'true';

  let opener = null;

  const close = () => {
    if (dialog.open) dialog.close();
  };

  const open = (key, trigger) => {
    const template = document.querySelector('[data-k-footer-overlay-template="' + key + '"]');
    if (!template) return false;

    opener = trigger;
    content.replaceChildren(template.content.cloneNode(true));
    document.body.classList.add('k-footer-overlay-open');
    dialog.showModal();
    requestAnimationFrame(() => closeButton.focus());
    return true;
  };

  footer.addEventListener('click', (event) => {
    const link = event.target.closest('[data-k-footer-overlay-link]');
    if (!link) return;

    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link.target === '_blank'
    ) return;

    if (open(link.dataset.kFooterOverlayLink, link)) event.preventDefault();
  });

  closeButton.addEventListener('click', close);

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close();
  });

  if (window.location.hash === '#FooterContact') open('contact', null);

  dialog.addEventListener('close', () => {
    document.body.classList.remove('k-footer-overlay-open');
    content.replaceChildren();
    opener?.focus({ preventScroll: true });
    opener = null;
  });
})();